import { Component, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { IDropdownListPublisher, IpublisherPage, Page, NewDns } from '../../../../shared/filters/filters';
import { AccountService } from '../../../../shared/services/admServices/accounts.service';
import { SystemService } from '../../../../shared/services/admServices/system.service'
import { ToastrService } from 'ngx-toastr';
import { SettingsDnsSingle } from '../../../../models/admModel/system.model';


declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'dns-component',
  templateUrl: './dns-component.html',
  styleUrls: ['./dns-component.scss']
})

export class dnsComponent implements OnInit {

  currentDns = new SettingsDnsSingle();
  public dnsData: any[] = [];
  public selected: any[] = [];
  newDns = new NewDns();
  isDefaultDns?: boolean;

  selectedItemsPublisher: any[] = [];
  selectedEditPublisher : Array<IDropdownListPublisher> = [{item_id: 0, item_text:""},];

  dropdownListPublisher : Array<IDropdownListPublisher> = [{item_id: 0, item_text:""},];
  dropdownListEditPublisher : Array<IDropdownListPublisher> = [{item_id: 0, item_text:""},];
  dropdownSettingsPublisher : IDropdownSettings = {};
  
  publisherPage : IpublisherPage = { pageNumber:1, pageSize:40, isAdminWithPublisherAccountIncluded:true };

  sendpage = new Page();
  page = new Page();
  pageSizeDefinition = 6;

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  constructor(private accountService: AccountService, private  systemService: SystemService, private toastrService: ToastrService) {
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
  }

  ngOnInit() {
    // get Publishers for dropdown
    this.getPublishers();
    this.dropdownSettingsPublisher = {
            singleSelection: false,
            idField: "item_id",
            textField: "item_text",
            selectAllText: "Select All",
            unSelectAllText: "UnSelect All",
            itemsShowLimit: 3,
            allowSearchFilter: true
      };

    this.setPage({  offset: 0 });
  }

   setPage(pageInfo){
    this.sendpage.pageNumber = pageInfo.offset+1;
    this.sendpage.size = this.pageSizeDefinition;

    this.systemService.getDns(this.sendpage)
    .subscribe(
      data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;

      this.dnsData = data.data.dns;
      this.selected = [this.dnsData[0]];
      this.currentDns.id = this.dnsData[0].id;
      this.currentDns.dnsName =this.dnsData[0].dnsName;
      this.currentDns.dnsStatus = this.dnsData[0].dnsStatus;
      this.currentDns.isDefault= this.dnsData[0].isDefault;
      this.isDefaultDns = this.currentDns.isDefault;

      if(this.dnsData[0].publishers.length>0)
      {
        this.currentDns.publishers=[];
        this.selectedEditPublisher=[];
        for(var i=0; i<this.dnsData[0].publishers.length; i++)
        {
          this.selectedEditPublisher.push({item_id: this.dnsData[0].publishers[i].id, item_text: this.dnsData[0].publishers[i].firstName + " " + this.dnsData[0].publishers[i].lastName})
          this.currentDns.publishers[i] = this.dnsData[0].publishers[i].id;
        }
      }

      },
      error => {
        console.log(error);
      });

  }

  getPublishers(){
    // API pobrania listy publisherów
    this.accountService.getAllPublishers(this.publisherPage)
    .subscribe(
     data => {
      this.dropdownListPublisher = [];
      this.dropdownListEditPublisher = [];
      data.data.publishers.forEach((value, index) => {
        this.dropdownListPublisher.push({item_id: value.id, item_text: value.firstName + " " + value.lastName});
        this.dropdownListEditPublisher.push({item_id: value.id, item_text: value.firstName + " " + value.lastName});
      });

     },
     error => {
       console.log(error);
     });

  }

  // selectAllForDropdownItems(items: any[]) {
  //   let allSelect = items => {
  //     items.forEach(element => {
  //       element['selectedAllGroup'] = 'selectedAllGroup';
  //     });
  //   };

  //   allSelect(items);
  // }

  onSelect({ selected }) {
    // wybór wiersza DNS w tabeli
    this.currentDns.id = selected[0].id;
    this.currentDns.dnsName = selected[0].dnsName;
    this.currentDns.dnsStatus = selected[0].dnsStatus;
    this.isDefaultDns = selected[0].isDefault;

    if(this.selected[0].publishers.length>0)
    {
      this.selectedEditPublisher=[];
      for(var i=0; i<this.selected[0].publishers.length; i++)
        this.selectedEditPublisher.push({item_id: this.selected[0].publishers[i].id, item_text: this.selected[0].publishers[i].firstName + " " + this.selected[0].publishers[i].lastName})
    }
  }

  onAdd(){
    if(this.newDns.dnsName!="")
    {
      if(this.selectedItemsPublisher.length>0)
      {
        // dane wypełnione poprawnie można zapisywać
        this.newDns.publishers = [];
        for(var i=0; i<this.selectedItemsPublisher.length; i++)
              this.newDns.publishers[i] = this.selectedItemsPublisher[i].item_id;

        this.systemService.registerDns(this.newDns)
        .subscribe(
          data => {
            this.toastrService.success('New DNS created.', 'Success !');
            this.selectedItemsPublisher = [];
            this.newDns.dnsName="";
            this.setPage({  offset: 0 });
          },
          error => {
            console.log(error);
            this.toastrService.error('Create data failed.', 'Error !');
          });

      }
      else
        this.toastrService.error('Publishers need to be selected.', 'Error !');
    }
    else
      this.toastrService.error('Please name the new DNS.', 'Error !');
  }

  onDelete(req){
  // zabezpieczenie przed usunięciem default DNS
    if(req.isDefault==true)
      this.toastrService.error('You cannot delete the default DNS.', 'Error !')
    else
    {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.systemService.deleteDns(req.id)
          .subscribe(
            response => {
              Swal.fire(
              'Deleted!',
              'Your DNS has been deleted.',
              'success'
              )
              this.setPage({ offset: 0 });
            },
            error => {
              console.log(error);
            });
        }
      })
    }

  }

  onUpdate(){
    if(this.isDefaultDns==true)
      this.currentDns.dnsStatus="on";

    this.currentDns.isDefault = this.isDefaultDns;
    this.currentDns.publishers = [];
    for(var i=0; i<this.selectedEditPublisher.length; i++)
      this.currentDns.publishers[i] = this.selectedEditPublisher[i].item_id;

    this.UpdateDns(this.currentDns);
  }

  UpdateDns(data: any){
    this.systemService.updateDns(data)
    .subscribe(
      data => {
        this.toastrService.success('DNS data updated.', 'Success !');
        this.setPage({  offset: 0 });
      },
      error => {
        console.log(error);
        this.toastrService.error('Update data failed.', 'Error !');
      });
  }

  onStatus(req) {
    // zabezpieczenie przed deaktywacją default DNS
    if(req.isDefault==true)
      this.toastrService.error('You cannot disabled the default DNS.', 'Error !')
    else
    {
      this.currentDns.id=req.id;
      this.currentDns.dnsName=req.dnsName;
      this.currentDns.isDefault=req.isDefault;
      this.currentDns.publishers = [];
      for(var i=0; i<req.publishers.length; i++)
        this.currentDns.publishers[i] = req.publishers[i].id;

      if(req.dnsStatus=="on")
        this.currentDns.dnsStatus = "off";
      else
      this.currentDns.dnsStatus = "on";

      this.UpdateDns(this.currentDns);
    }
  }

  onItemSelectPublisher(item: any) {
    //console.log("onItemSelect", item);
  }
  onSelectAllPublisher(items: any) {
    //console.log("onSelectAll", items);
  }

}
